import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ToastWrapper = () => {
  return (
    <ToastContainer
      position="top-center"
      autoClose={3000}
      hideProgressBar={true}
      newestOnTop={true}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable={false}
      pauseOnHover
      theme="light"
      style={{
        top: '50px',
        margin: '0 auto',
        padding: '0',
      }}
      toastStyle={{
        width: 'auto',
        maxWidth: '90vw',
        marginBottom: '12px',
        borderRadius: '8px',
        padding: '0',
        minHeight: '52px',
        backgroundColor: 'transparent',
        boxShadow: 'none',
      }}
      closeButton={false}
      icon={false}
      transition={Slide}
    />
  );
};

export default ToastWrapper;
